import wsClient from "../core/wsClient";
import uiService from "./ui.service";
import { store } from "../../store/store";
import { setSessionProgress } from "../../store/slices/session.slice";
import type { ICampaignWizardForm } from "../../types/form.type";
import type { IFormSubmitEvent } from "../events/form/form.submit";

const formService = {
	submitCampaignWizard(
		formData: ICampaignWizardForm,
		userId: string,
		accountId: string,
	) {
		const customerId = accountId.replace(/-/g, "");

		const payload: IFormSubmitEvent = {
			type: "agentic_router.dispatch",
			action: "submit_campaign_wizard",
			user_id: userId,
			campaign_form_raw: formData.campaign_form_raw,
			campaign_context: {
				...formData.campaign_context,
				customer_id: customerId,
			},
		};

		// Замораживаем UI и сбрасываем прогресс
		store.dispatch(setSessionProgress(0));
		uiService.handleFreeze();

		wsClient.sendMessage(payload);
	},
};

export default formService;
